import React from 'react'

const Policies = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/policies',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.2'
    >
      <path
        d='M3.3 16c-.415 0-.8-.433-.8-.833V1.833c0-.4.385-.833.8-.833h10.4c.415 0 .8.433.8.833v13.334c0 .4-.385.833-.8.833H3.3z'
        stroke={primaryColor}
      />
      <path
        d='M14.5 4h2.2c.415 0 .8.433.8.833v13.334c0 .4-.385.833-.8.833H6.3c-.415 0-.8-.433-.8-.833V16'
        stroke={primaryColor}
      />
      <path d='M5 4h7M5 7h7M5 10h7M5 13h5' stroke={secondaryColor} />
    </g>
  </svg>
)

export default Policies
